import { Sun, CloudSun, Cloud, CloudRain, CloudLightning, CloudDrizzle, Wind, CloudFog } from "lucide-react";

export function weatherIcon(icon = "") {
  const m = {
    sun: Sun, clear: Sun,
    "cloud-sun": CloudSun,
    cloud: Cloud, clouds: Cloud, cloudy: Cloud,
    "cloud-rain": CloudRain, "cloud-showers": CloudRain, "cloud-showers-heavy": CloudRain,
    "cloud-drizzle": CloudDrizzle, drizzle: CloudDrizzle,
    "cloud-bolt": CloudLightning, bolt: CloudLightning, thunderstorm: CloudLightning,
    wind: Wind, smog: CloudFog, fog: CloudFog, mist: CloudFog,
  };
  return m[icon] || Cloud;
}

export function skyGradient(icon = "", storm = "none") {
  if (storm === "warning") return "linear-gradient(158deg,#3B1220 0%,#160810 100%)";
  if (icon.includes("bolt")) return "linear-gradient(158deg,#2A2350 0%,#0E1030 100%)";
  if (icon.includes("rain") || icon.includes("drizzle")) return "linear-gradient(158deg,#2B4A6F 0%,#0F2036 100%)";
  if (icon.includes("cloud") || icon.includes("fog") || icon.includes("smog")) return "linear-gradient(158deg,#3E6AA8 0%,#173257 100%)";
  return "linear-gradient(158deg,#2E7BD6 0%,#1E4DB7 100%)";
}
